export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1024w.8f00e5a7.avif";